export default "__VITE_ASSET__5505a4a5__"